import security from "../../../main";
import { getApiBaseUrl } from "@/config";

export default {
    events: {
        edit    : "edit",
        save    : "save",
        undelete: "undelete",
        saved   : "saved",
        delete  : "delete",
        deleted : "deleted",
        undeleted: "undeleted",
        cancel  : "cancel"
    },

    journal: {
        type: {
            phone       : "PHONE",
            email       : "EMAIL",
            notice      : "CONVERSATION",
            reminder    : "REMINDER",
            document    : "DOCUMENT",
            postponement: "POSTPONEMENT",
            clipboard   : "CLIPBOARD"
        }
    },

    url: {
        top    : '/api/crm/reminder',
        total  : '/api/crm/reminder/total',
        confirm: '/api/crm/reminder/{0}/confirm',
        journal: '/api/crm/',
        entry  : '/api/crm/journal',
        filter : '/api/crm/filter',
    },

    save: function (type, entry, success) {
        let url = this.url.entry;
        if (entry.id !== null) {
            url = url + "/" + entry.id;
        }

        entry.type.id  = type;
        fetch(getApiBaseUrl() + url,{
            method : entry.id === null  ? "POST" : "PUT",
            headers: security.jsonHeader() ,
            body   : JSON.stringify(entry),
        })
            .then(() => {
                success();
            })
            .catch((e) => {
                console.log(e)
            })
    },

    delete: function (id, success) {
        let url = this.url.entry + "/" + id;
        fetch(getApiBaseUrl() + url,{
            method : "DELETE",
            headers: security.jsonHeader() ,
        })
            .then(() => {
                success();
            })
            .catch(() => {
            })
    },

    confirm: function (id, success, error) {
        fetch(getApiBaseUrl() + this.url.confirm.replace("{0}", id), {
            method: "PUT",
            headers: security.header(),
        })
            .then(data => security.response (data, error))
            .then(data => success (data))
            .catch(error => console.error(error))
        ;
    }
}